import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { CompanyLogo } from "../types";

/**
 * Guarda el UUID del logotipo previamente subido al servicio de archivos.
 */
export const updateCompanyLogo = (uuid_logo: string) => {
  return apiClient<ApiResponse<CompanyLogo>>("/v1/empresa/logo", {
    method: "PUT",
    body: { uuid_logo },
  });
};
